export default __webpack_public_path__ + "static/media/msort_lista_td.fbd6e0c9.md";